module.exports = __webpack_public_path__ + "static/media/main idea.50f9643c.mp3";